import { render } from "./Investors.vue?vue&type=template&id=7c2b549d&scoped=true"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7c2b549d"

export default script